export default __webpack_public_path__ + "static/media/logo-short.6158de38.svg";